import type { ToggleWidget } from '../../../widgets';
import {
  BindingRow,
  Row,
  ScalarField,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Schalter. Zwei Punkte, weil die Stellung der Rueckmeldung folgt und nicht
 *  dem Klick: ein misslungener Schreibvorgang bleibt so sichtbar. */
export function ToggleEditor(
  { widget, plantId, onChange }: WidgetEditorProps<ToggleWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Befehls-Datenpunkt"
          value={widget.commandPoint}
          plantId={plantId}
          filter={{ writable: true }}
          onChange={(next) => patch({ commandPoint: next })}
        />
        <BindingRow
          label="Rückmelde-Datenpunkt"
          value={widget.feedbackPoint}
          plantId={plantId}
          hint="Der Punkt, den der Regler zurückmeldet. Darf derselbe sein."
          onChange={(next) => patch({ feedbackPoint: next })}
        />
      </Section>
      <Section title="Werte und Beschriftung">
        <Row>
          <ScalarField
            label="Wert für Ein"
            value={widget.onValue}
            onChange={(next) => patch({ onValue: next })}
          />
          <ScalarField
            label="Wert für Aus"
            value={widget.offValue}
            onChange={(next) => patch({ offValue: next })}
          />
        </Row>
        <Row>
          <TextField
            label="Beschriftung Ein"
            value={widget.onLabel}
            placeholder="Ein"
            onChange={(next) => patch({ onLabel: next })}
          />
          <TextField
            label="Beschriftung Aus"
            value={widget.offLabel}
            placeholder="Aus"
            onChange={(next) => patch({ offLabel: next })}
          />
        </Row>
      </Section>
    </>
  );
}
